<template>
    <div class="main-content " v-cloak>
        <div class="container">
            <div class="form-success" v-if="user_save_success">
                <div class="icon-success-big"></div>
                <div class="form-success-title">Successfully changed!</div>
                <p>Your info has been updated!</p>
            </div>
            <div class="form-container" v-else>
                <div class="form-wrapper">
                    <div class="form-hor">
                        <div class="form-col">
                            <custom-input
                                @change="set_value"
                                input_type="name"
                                :name_capitalization="true"
                                :value="user.full_name"
                                name="full_name"
                                label="Name"
                            ></custom-input>
                        </div>

                        <div class="form-col">
                            <custom-input
                                disabled="True"
                                input_type="email"
                                @change="set_value"
                                :value="user.email"
                                limit="60"
                                hint="Hint! Max 60 characters"
                                :invalid="errors && errors.includes('email')"
                                error_msg="* Invalid e-mail"
                                name="email"
                                label="E-mail"
                            ></custom-input>
                        </div>
                    </div>
                    <div class="form-hor">
                        <div class="form-col">
                            <div class="form-col-wrapper">
                                <div class="country" v-if="countries && countries.length > 0">
                                    <dropdown
                                        @selected="set_drop_value"
                                        :unsort="true"
                                        :autosuggest="true"
                                        :value="user.country_code"
                                        name="country_code"
                                        label="Country code"
                                        :options="countries"
                                    ></dropdown>
                                </div>
                                <div style="flex:1;">
                                    <custom-input
                                        limit="20"
                                        @change="set_value"
                                        input_type="phone"
                                        hint="Hint! Max 20 characters"
                                        :value="user.phone"
                                        name="phone"
                                        label="Phone number"
                                    ></custom-input>
                                </div>
                            </div>
                        </div>

                        <div class="form-col">
                            <custom-input
                                input_type="address"
                                @change="set_value"
                                :value="user.address"
                                name="address"
                                label="Address"
                            ></custom-input>
                        </div>
                    </div>
                </div>
            </div>
            <a
                @click="save"
                v-if="!user_save_success"
                href="javascript:{}"
                :class="{ 'btn btn-primary': true, disabled: isDisabled }"
                >Save</a
            >
            <div class="text-container" v-if="user.payment_method" style="margin-bottom: 6.2rem;">
                <div class="title">Current payment method:</div>
                <p class="price"><span>Card:</span> **** **** **** {{ user.payment_method.last_digits }}</p>
                <p class="price"><span>Expires at</span>: {{ user.payment_method.expiration_date }}</p>
                <div class="btn-container" style="display:flex;">
                    <a @click="update" href="javascript:{}" :class="{ 'btn btn-default': true }"
                        >Update payment method</a
                    >
                </div>
            </div>
            <div v-if="payment_change_modal_shown">
                <payment-change-modal v-if="payment_change_modal_shown" @close-modal="hidePaymentChangeModal">
                </payment-change-modal>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import json from "./countries.json";
import PaymentChangeModal from "./payment-edit-modal";

export default {
    name: "settings",
    components: { dropdown, customInput, PaymentChangeModal },

    data() {
        let countries = [];
        let codes = [];
        json.forEach(x => {
            if (!codes.includes(x.code)) {
                codes.push(x.code);
                let obj = {
                    value: x.code,
                    label: x.code
                };
                countries.push(obj);
            }
        });

        return {
            payment_change_modal_shown: false,
            countries: countries,
            errors: [],
            isDisabled: true,
            changedSuccessully: false,
            phone: null,
            address: null,
            country_code: null
        };
    },
    computed: {
        ...mapState(["user", "user_save_success"])
    },
    watch: {},
    mounted() {},
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_user_data_success(false);
            vm.get_logged_in_user();
            next();
        });
    },
    methods: {
        ...mapMutations(["update_field", "set_user", "set_user_data_success"]),
        ...mapActions(["save_user"]),
        ...mapActions(["get_logged_in_user"]),
        get_name_parts(str) {
            var full_name_split = str.split(" ");
            var first_name = full_name_split[0];
            var last_name = full_name_split.length > 1 ? full_name_split[full_name_split.length - 1] : null;
            return { first_name, last_name };
        },
        set_drop_value(payload) {
            this.isDisabled = false;
            this.user[payload.name] = payload.value;
        },
        async save() {
            this.errors = [];
            this.set_user_data_success(false);
            if (!this.user.email) {
                this.errors.push("email");
            }
            if (this.user.email && !window.validate_email(this.user.email)) {
                if (!this.errors.includes("email")) {
                    this.errors.push("email");
                }
            }
            if (this.errors.length === 0) {
                if (this.user.full_name) {
                    let name_parts = this.get_name_parts(this.user.full_name);
                    this.user.first_name = name_parts.first_name;
                    this.user.last_name = name_parts.last_name;
                } else {
                    this.user.first_name = null;
                    this.user.last_name = null;
                }
                let resp = await this.save_user(this.user);
            }
        },
        update() {
            this.showPaymentChangeModal();
        },
        hidePaymentChangeModal() {
            this.payment_change_modal_shown = false;
        },
        showPaymentChangeModal() {
            this.payment_change_modal_shown = true;
        },
        set_value(args) {
            //if (args.prop_name === "phone") {
            //    args.prop_value = args.prop_value.replace(/[^0-9]/g, "");
            //}
            this.isDisabled = false;
            this.user[args.prop_name] = args.prop_value;
        }
    },
    created() {}
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        padding: 4rem 1.6rem 0 1.6rem;
    }
}

.btn-primary {
    padding: 0.8rem 1.6rem;
    margin-left: auto;
    align-items: flex-start; /* NEW */
    margin-bottom: 4.2rem;
}

.form-col-wrapper {
    display: flex;
    margin: 0 -1.2rem;
}

@media (max-width: 350px) {
    .form-col-wrapper {
        flex-direction: column;
    }
}

.form-col-wrapper .form-group {
    padding: 0 1.2rem;
}

.container {
    display: flex;
    flex-direction: column;
}

.form-success {
    margin-top: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-col-wrapper .country {
    flex: initial;
    width: 16.8rem;
}

.form-success-title {
    margin-top: 1.2rem;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #000000;
}
.title {
    font-size: 1.2rem;
    line-height: 2.4rem;
    font-weight: 600;
    color: #000;
    letter-spacing: 0.02em;
}

.price {
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
}

.price span {
    font-weight: 500;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.btn-link,
.btn-link:hover,
.btn-link:active,
.form-success p {
    margin-top: 0.8rem;
    font-size: 1.2rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #717171;
}
</style>
